module.exports = __webpack_public_path__ + "static/img/19017B_1_C_20210223_fit.98ed2f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19017B_1_C_20210223_fit.png
// module id = 8bEN
// module chunks = 0